document.addEventListener('DOMContentLoaded', (event) => {
  // click event of stucks start
  let stuckInputs = document.querySelectorAll('.bundle-grid label.bundle-card input');

  stuckInputs.forEach((input) => {
    input.addEventListener('change', function () {
      if (this.checked) {
        // box quantity
        let boxQty = this.value;
        if (document.querySelectorAll('.freq-options label').length > 0) {
          document.querySelectorAll('.freq-options label')[boxQty - 1].click();
        }

        // pricing
        let subscriptionPrice = this.getAttribute('data-origin-price');
        let comparePrice = this.getAttribute('data-compare-price');
        let oneTimeComparePrice = this.getAttribute('data-without-gift-compare');
        let oneTimePrice = this.getAttribute('data-onetime-price');

        // price blocks
        let subsOriginPriceBlock = document.querySelector('.subs-pricing span.subs_origin_price');
        let subsComparePriceBlock = document.querySelector('.subs-pricing s');
        let otOriginPriceBlock = document.querySelector('.onetime-pricing .ot_origin_price');
        let otComparePriceBlock = document.querySelector('.onetime-pricing s');
        let qtyLimit = document.querySelector('.box_badge_inner span');

        if (subsOriginPriceBlock) {
          subsOriginPriceBlock.innerHTML = subscriptionPrice;
        }
        if (subsComparePriceBlock) {
          subsComparePriceBlock.innerHTML = comparePrice;
        }
        if (otComparePriceBlock) {
          otComparePriceBlock.innerHTML = oneTimeComparePrice;
        }
        if (otOriginPriceBlock) {
          otOriginPriceBlock.innerHTML = oneTimePrice;
        }
        if (qtyLimit) {
          qtyLimit.innerHTML = boxQty;
        }
        if (document.querySelector('.box_badge_inner')) {
          document.querySelector('.box_badge_inner').dataset.limit = boxQty;
        }

        getSelectedPrice();
        initScentPicker();
      }
    });
  });
  // click event of stucks end

  // price block update function
  function priceBlockUpdate() {
    let bundleCardInput = document.querySelector('.bundle-card input:checked');
    let perWashPrice = bundleCardInput.closest('.bundle-card').querySelector('#per_wash').textContent;

    document.querySelector('.box_pricing_bar #per_wash_price').innerHTML = perWashPrice;

    //percentage changes
    let checkedPurchaseOption = document.querySelector('.subs-box-options label.option-card > input:checked').value;
    let percentageEl = document.querySelector('.saving_bar__percent .percentage');

    let subPercentage = bundleCardInput.getAttribute('data-subscription-discount');
    let subscriptionBadgeEl = document.querySelector('.sub-badge span');
    let subscriptionToggleBadge = document.querySelector('.toggle-box-header .sub-percent span');
    if (subscriptionBadgeEl) {
      subscriptionBadgeEl.innerHTML = subPercentage;
    }
    if (subscriptionToggleBadge) {
      subscriptionToggleBadge.innerHTML = subPercentage;
    }
    if (checkedPurchaseOption === 'subscription_op') {
      if (percentageEl) {
        const subPercentageValue = parseFloat(subPercentage);

        if (subPercentageValue > 0) {
          percentageEl.innerHTML = subPercentage;
          percentageEl.style.display = '';
        } else {
          percentageEl.style.display = 'none';
        }
      }
    } else {
      let otPercentage = bundleCardInput.getAttribute('data-onetime-discount');

      if (percentageEl) {
        const percentageValue = parseFloat(otPercentage);

        if (percentageValue > 0) {
          percentageEl.innerHTML = otPercentage;
          percentageEl.style.display = '';
        } else {
          percentageEl.style.display = 'none';
        }
      }
    }
  }
  // price block update function

  // click event of subscription and onetime
  let purchaseOptions = document.querySelectorAll('.subs-box-options .option-card > input');
  purchaseOptions.forEach((input) => {
    input.addEventListener('change', function () {
      if (this.value == 'oneime_op') {
        document.querySelectorAll('.bundle-card').forEach((card) => {
          const infoInput = card.querySelector('input[type="radio"]');
          const perWashEl = card.querySelector('#per_wash');

          if (infoInput && perWashEl) {
            const perWash = infoInput.dataset.onetimePerWash;
            perWashEl.textContent = `${perWash}`;
          }
        });
      } else {
        document.querySelectorAll('.bundle-card').forEach((card) => {
          const infoInput = card.querySelector('input[type="radio"]');
          const perWashEl = card.querySelector('#per_wash');

          if (infoInput && perWashEl) {
            const perWash = infoInput.dataset.subsPerWash;
            perWashEl.textContent = `${perWash}`;
          }
        });
      }

      getSelectedPrice();
      priceBlockUpdate();
      syncVariantInputs();
    });
  });
  // click event of subscription and onetime

  let frequecyInputs = document.querySelectorAll('.freq-options input');
  frequecyInputs.forEach((input) => {
    input.addEventListener('change', function () {
      priceBlockUpdate();
      syncVariantInputs();
    });
  });

  // update pricing function start
  function getSelectedPrice() {
    const selectedOption = document.querySelector('.subs-box-options input[name="purchase_option"]:checked');
    if (!selectedOption) return;

    let pricingBlock = document.querySelector(`.${selectedOption.value}.option-card`);
    if (!pricingBlock) return;

    let originEl, compareEl;
    if (selectedOption.value === 'subscription_op') {
      originEl = pricingBlock.querySelector('.subs_origin_price');
      compareEl = pricingBlock.querySelector('.subs-pricing s');
    } else {
      originEl = pricingBlock.querySelector('.ot_origin_price');
      compareEl = pricingBlock.querySelector('.onetime-pricing s');
    }

    const originPrice = originEl?.textContent?.trim();
    const comparePrice = compareEl?.textContent?.trim();

    let totalOriginPriceBlock = document.querySelector('.saving_bar__percent .origin_price');
    let totalComparePriceBlock = document.querySelector('.saving_bar__percent .compare_price');

    if (totalOriginPriceBlock) {
      totalOriginPriceBlock.innerHTML = originPrice;
    }
    if (totalComparePriceBlock) {
      totalComparePriceBlock.innerHTML = comparePrice;
      if (originPrice === comparePrice) {
        totalComparePriceBlock.style.display = 'none';
      } else {
        totalComparePriceBlock.style.display = '';
      }
    }

    return { originPrice, comparePrice };
  }
  // update pricing function end

  const getQuantityLimit = () => Number(document.querySelector('.box_qty_badge .box_badge_inner')?.dataset.limit || 0);

  const syncVariantInputs = () => {
    const sellingPlan = getSelectedSellingPlan();

    // Disable and clear ALL variant inputs first
    document
      .querySelectorAll('.product-variant-id, .product-variant-qty, .product-variant-selling-plan')
      .forEach((input) => {
        input.disabled = true;
        input.value = '';
      });

    // Disable all properties inputs first
    document
      .querySelectorAll(
        'input[name*="[properties][_box]"], input[name*="[properties][_parent_product_handle]"], input[name*="[properties][_parent_product_id]"]'
      )
      .forEach((input) => {
        input.disabled = true;
      });

    // Enable and populate inputs only for active scent items
    document.querySelectorAll('.scent-item').forEach((item) => {
      const variantId = item.dataset.variantId;
      const qtyBox = item.querySelector('.qty-box');
      const qty = parseInt(item.querySelector('.qty')?.textContent || 0);
      const isActive = qtyBox && qtyBox.style.display !== 'none' && qty > 0;

      if (isActive) {
        const idInput = document.querySelector(`.product-variant-id[data-variant-id="${variantId}"]`);
        const qtyInput = document.querySelector(`.product-variant-qty[data-variant-id="${variantId}"]`);
        const spInput = document.querySelector(`.product-variant-selling-plan[data-variant-id="${variantId}"]`);

        if (idInput) {
          idInput.disabled = false;
          idInput.value = variantId;

          // Enable properties inputs only for subscription
          if (sellingPlan !== '') {
            const nameAttr = idInput.name;
            let prefix;
            if (nameAttr === 'id') {
              prefix = 'items[0]';
            } else {
              prefix = nameAttr.replace('[id]', '');
            }
            document
              .querySelectorAll(
                `input[name="${prefix}[properties][_box]"], input[name="${prefix}[properties][_parent_product_handle]"], input[name="${prefix}[properties][_parent_product_id]"]`
              )
              .forEach((propInput) => {
                propInput.disabled = false;
              });
          }
        }
        if (qtyInput) {
          qtyInput.disabled = false;
          qtyInput.value = qty;
        }
        if (spInput) {
          if (sellingPlan !== '') {
            spInput.disabled = false;
            spInput.value = sellingPlan;
          }
          // one-time: leave disabled and empty (already reset in the loop above)
        }
      }
    });

    updateAddToCart();
  };

  const getSelectedSellingPlan = () => {
    const purchaseOption = document.querySelector('.subs-box-options input[name="purchase_option"]:checked');

    // If one-time is selected, always return empty
    if (!purchaseOption || purchaseOption.value !== 'subscription_op') return '';

    const freqInput = document.querySelector('.freq-options input:checked');
    if (!freqInput) return '';
    const val = freqInput.getAttribute('data-selling-id');
    return val ? Number(val) : '';
  };

  const updateAddToCart = () => {
    const limit = getQuantityLimit();
    const total = getTotalSelected();
    const addToCartBtn = document.querySelector('.buy_box_btn[name="add"]');
    if (addToCartBtn) {
      addToCartBtn.disabled = total !== limit;
    }
  };

  const getTotalSelected = () => {
    let total = 0;
    document.querySelectorAll('.scent-item').forEach((item) => {
      const qtyBox = item.querySelector('.qty-box');
      if (qtyBox && qtyBox.style.display !== 'none') {
        total += parseInt(item.querySelector('.qty')?.textContent || 0);
      }
    });
    return total;
  };

  function initScentPicker() {
    const updateBtnStates = () => {
      const limit = getQuantityLimit();
      const total = getTotalSelected();
      const limitReached = total >= limit;

      document.querySelectorAll('.scent-item').forEach((item) => {
        const qtyBox = item.querySelector('.qty-box');
        const addBtn = item.querySelector('.add-btn');
        const plusBtn = item.querySelector('.plus');

        const isActive = qtyBox && qtyBox.style.display !== 'none';

        // disable .add-btn if limit reached and item not already added
        if (addBtn) addBtn.disabled = limitReached;

        // disable .plus if limit reached
        if (plusBtn) plusBtn.disabled = limitReached;
      });
    };

    const updateBadgeText = () => {
      const limit = getQuantityLimit();
      const total = getTotalSelected();
      const remaining = limit - total;
      const badgeInner = document.querySelector('.box_badge_inner p');
      if (!badgeInner) return;

      if (remaining <= 0) {
        badgeInner.innerHTML = 'All scents selected';
      } else {
        badgeInner.innerHTML = `<span>${remaining}</span> Scent to go`;
      }
    };

    // Reset all scent items to initial state
    document.querySelectorAll('.scent-item').forEach((item) => {
      const addBtn = item.querySelector('.add-btn');
      const qtyBox = item.querySelector('.qty-box');
      const qtySpan = item.querySelector('.qty');

      // Reset visual state
      qtyBox.style.display = 'none';
      addBtn.style.display = 'flex';
      qtySpan.textContent = 1;

      // Clone nodes to remove old event listeners before re-attaching
      const newAddBtn = addBtn.cloneNode(true);
      const newQtyBox = qtyBox.cloneNode(true);
      addBtn.replaceWith(newAddBtn);
      qtyBox.replaceWith(newQtyBox);

      // Re-query fresh references after clone
      const freshAddBtn = item.querySelector('.add-btn');
      const freshQtyBox = item.querySelector('.qty-box');
      const freshQtySpan = item.querySelector('.qty');
      const freshPlus = item.querySelector('.plus');
      const freshMinus = item.querySelector('.minus');

      freshQtyBox.style.display = 'none';

      freshAddBtn.addEventListener('click', () => {
        const limit = getQuantityLimit();
        const total = getTotalSelected();
        if (total >= limit) return;

        freshQtySpan.textContent = 1;
        freshQtyBox.style.display = 'flex';
        freshAddBtn.style.display = 'none';
        syncVariantInputs();
        updateBtnStates();
        updateBadgeText();
      });

      freshPlus.addEventListener('click', () => {
        const limit = getQuantityLimit();
        const total = getTotalSelected();
        if (total >= limit) return;

        const current = parseInt(freshQtySpan.textContent || 0);
        freshQtySpan.textContent = current + 1;
        syncVariantInputs();
        updateBtnStates();
        updateBadgeText();
      });

      freshMinus.addEventListener('click', () => {
        const current = parseInt(freshQtySpan.textContent || 0);
        if (current <= 1) {
          freshQtySpan.textContent = 1;
          freshQtyBox.style.display = 'none';
          freshAddBtn.style.display = 'flex';
        } else {
          freshQtySpan.textContent = current - 1;
        }
        syncVariantInputs();
        updateBtnStates();
        updateBadgeText();
      });
    });

    // Initial sync
    syncVariantInputs();
    updateBtnStates();
    updateBadgeText();
  }
  initScentPicker();

});
